import {
  PricingAccountRow,
  PricingGroupRow,
  VariantPackCostChange,
} from '@/experiences/sales-portal/domain/pricing/screens/management/blocs/transformers/use-pricing-management-transformers';

export enum ColumnId {
  BookmarkedDate = 'bookmarkedDate',
  Category = 'category',
  Checkbox = 'checkbox',
  CostDelta = 'costDelta',
  CurrentCost = 'currentCost',
  CurrentGrossMargin = 'currentGrossMargin',
  CurrentPrice = 'currentPrice',
  EditsGrossProfitImpactPerOrder = 'editsGrossProfitImpactPerOrder',
  GrossMarginPercentageDelta = 'grossMarginPercentageDelta',
  GrossProfit = 'grossProfit',
  Id = 'id',
  LastCost = 'lastCost',
  LastMargin = 'lastMargin',
  LastPrice = 'lastPrice',
  Name = 'name',
  PeerRange = 'peerRange',
  PriceDelta = 'priceDelta',
  UOM = 'uom',
  VolumePerOrder = 'volumePerOrder',
  WeeklyCostChangeGrossProfitImpact = 'weeklyCostChangeGrossProfitImpact',
  WeeklyEditsGrossProfitImpact = 'weeklyEditsGrossProfitImpact',
  WeeklyNetGrossProfitImpact = 'weeklyNetGrossProfitImpact',
  WeeklyPurchaseQuantities = 'weeklyPurchaseQuantities',
  WeeklyVolume = 'weeklyVolume',
}

export type PricingGroupedTableRow = PricingGroupRow | PricingAccountRow;

export type PricingItemManagementTableRow =
  | VariantPackCostChange
  | PricingAccountRow;

export enum ArrowDirection {
  Down = 'Down',
  Up = 'Up',
}
